var _line, _line2, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAssetAllocation = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 19,
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 3.34219,
  y1: 15.6022,
  x2: 9.43933,
  y2: 9.54907,
  stroke: "currentColor"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 9.5,
  y1: 9.5918,
  x2: 9.5,
  y2: 1.0002,
  stroke: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.38147 9.52777L18.5006 9.50043",
  stroke: "currentColor"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 9.5,
  cy: 9.5,
  r: 9,
  stroke: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAssetAllocation);
export { ForwardRef as ReactComponent };